import { render } from "./NoteRow.vue?vue&type=template&id=9885260a&scoped=true"
import script from "./NoteRow.vue?vue&type=script&lang=js"
export * from "./NoteRow.vue?vue&type=script&lang=js"

import "./NoteRow.vue?vue&type=style&index=0&id=9885260a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9885260a"]])

export default __exports__